// extracted by mini-css-extract-plugin
module.exports = {"wrap":"header_wrap__1j2_M","navLink":"header_navLink__2lMkl","btn":"header_btn__4yx9n","regBtn":"header_regBtn__JMbDz"};